








import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import gql from 'graphql-tag';
import store from '@/store';

/* tslint:disable-next-line */
const bulmaCalendar = require('bulma-calendar/dist/js/bulma-calendar');

@Component({
  components: {
  },
})
export default class DateRangeSelector extends Vue {
  @Prop()
  public initialStartDate?: Date;

  @Prop()
  public initialEndDate?: Date;

  public mounted() {
    const results = bulmaCalendar.attach(this.$refs['date-range-selector'], {
      displayMode: 'dialog',
      isRange: true,
      clearButton: false,
      showFooter: false,
      showHeader: false,
      type: 'date',
      startDate: this.initialStartDate,
      endDate: this.initialEndDate,
    });
    for (const result of results) {
      result.datePicker.on('select', ({ data }: any) => {
        const { start, end } = data._date;
        this.$emit('range-selected', [new Date(start), new Date(end)]);
      });
    }
  }
}
